/* ============================================================
   vw-collection.js — faceted filtering, sorting, load-more and
   grid density for the VW Collection section.
   Filters are Shopify's own (Search & Discovery); every change is
   fetched through the Section Rendering API and only the regions
   marked data-swap are replaced, so open groups and the mobile
   drawer stay where they are.
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = $('[data-collection-root]');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const base = root.dataset.baseUrl;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');

  /* ---- grid density ------------------------------------- */
  let view = 4;
  try { view = Number(localStorage.getItem('vw_view')) || 4; } catch (e) {}
  function applyView() {
    const grid = $('[data-grid]', root);
    if (grid) grid.classList.toggle('pgrid--3', view === 3);
    $$('[data-view]', root).forEach(b => b.classList.toggle('is-on', Number(b.dataset.view) === view));
  }
  applyView();

  /* ---- fetch + swap -------------------------------------- */
  let ctrl;
  async function load(url, push) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    root.classList.add('is-loading');
    const u = new URL(url, location.origin);
    u.searchParams.delete('page');
    const fetchUrl = new URL(u);
    fetchUrl.searchParams.set('section_id', sectionId);
    try {
      const res = await fetch(fetchUrl.toString(), { signal: ctrl.signal });
      const doc = parse(await res.text());
      const openState = {};
      $$('[data-fgroup]', root).forEach(g => { openState[g.dataset.fgroup] = g.classList.contains('is-open'); });
      $$('[data-swap]', doc).forEach(fresh => {
        const cur = $('[data-swap="' + fresh.dataset.swap + '"]', root);
        if (cur) cur.innerHTML = fresh.innerHTML;
      });
      $$('[data-fgroup]', root).forEach(g => {
        if (g.dataset.fgroup in openState) g.classList.toggle('is-open', openState[g.dataset.fgroup] || !!g.querySelector('input:checked'));
      });
      applyView();
      topUp();
      if (push !== false) history.pushState({ vw: 1 }, '', u.pathname + u.search);
      if (window.VW) { VW.syncWish(); VW.reveal(root); }
    } catch (e) {
      if (e.name !== 'AbortError') location.href = u.toString();
    } finally {
      root.classList.remove('is-loading');
    }
  }

  function urlFromForm(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    const sort = $('[data-sort]', root);
    if (sort) params.set('sort_by', sort.value);
    return base + '?' + params.toString();
  }

  /* ---- events -------------------------------------------- */
  root.addEventListener('change', e => {
    if (e.target.matches('[data-sort]')) {
      const u = new URL(location.href);
      u.searchParams.set('sort_by', e.target.value);
      load(u.toString()).then(() => {
        const tools = $('.ctools', root);
        if (tools && window.scrollY > tools.offsetTop) window.scrollTo({ top: tools.offsetTop - 10, behavior: 'smooth' });
      });
      return;
    }
    const form = e.target.closest('[data-filter-form]');
    if (form && e.target.type === 'checkbox') {
      const sw = e.target.closest('.vswatch'); if (sw) sw.classList.toggle('is-on', e.target.checked);
      load(urlFromForm(form));
    }
  });

  let priceT;
  root.addEventListener('input', e => {
    const p = e.target.closest('[data-price]');
    if (!p) return;
    clearTimeout(priceT);
    priceT = setTimeout(() => load(urlFromForm(p.form)), 650);
  });

  root.addEventListener('submit', e => {
    const form = e.target.closest('[data-filter-form]');
    if (form) { e.preventDefault(); load(urlFromForm(form)); }
  });

  root.addEventListener('click', e => {
    const t = e.target;
    const pr = t.closest('[data-prange]');
    if (pr) {
      const form = pr.closest('[data-filter-form]');
      const [a, b] = pr.dataset.prange.split('|');
      const min = $('[data-price="min"]', form), max = $('[data-price="max"]', form);
      if (min) min.value = a; if (max) max.value = b;
      load(urlFromForm(form));
      return;
    }
    const chip = t.closest('.fapplied a, [data-clear]');
    if (chip && chip.href) { e.preventDefault(); load(chip.href); return; }
    const vw = t.closest('[data-view]');
    if (vw) {
      view = Number(vw.dataset.view);
      try { localStorage.setItem('vw_view', view); } catch (err) {}
      applyView();
      return;
    }
    const more = t.closest('[data-more]');
    if (more) {
      e.preventDefault();
      loadMore(more).catch(() => { location.href = more.href; });
    }
  });

  /* ---- sold-out last ------------------------------------
     Sold-out cards are held back while in-stock pages keep loading,
     then all shown at the end of the list. */
  async function loadMore(more) {
    more.classList.add('is-busy');
    const u = new URL(more.href, location.origin);
    u.searchParams.set('section_id', sectionId);
    const doc = parse(await (await fetch(u.toString())).text());
    const grid = $('[data-grid]', root);
    const freshGrid = $('[data-swap="grid"]', doc);
    const m = $('[data-swap="more"]', doc), cur = $('[data-swap="more"]', root);
    const ended = !(m && m.querySelector('[data-more]'));
    if (grid && freshGrid) {
      if (grid.hasAttribute('data-sold-last')) {
        // carry this page's held-back cards into the grid's holding template
        let hold = grid.querySelector('template[data-sold]');
        if (!hold) { hold = document.createElement('template'); hold.setAttribute('data-sold', ''); grid.appendChild(hold); }
        $$('template[data-sold]', freshGrid).forEach(t => { hold.innerHTML += t.innerHTML; t.remove(); });
        if (!ended) $$('.pcard.is-sold', freshGrid).forEach(c => { hold.innerHTML += c.outerHTML; c.remove(); });
        hold.before(...Array.from(freshGrid.childNodes));
        if (ended) releaseSold(grid);
      } else {
        grid.insertAdjacentHTML('beforeend', freshGrid.innerHTML);
      }
    }
    if (m && cur) cur.innerHTML = m.innerHTML;
    if (window.VW) { VW.syncWish(); VW.reveal(root); }
  }
  function releaseSold(grid) {
    const hold = grid.querySelector('template[data-sold]');
    if (!hold) return;
    const sold = hold.innerHTML; hold.remove();
    grid.insertAdjacentHTML('beforeend', sold);
  }
  // If a page was mostly sold out, top up with the next page(s) of in-stock watches
  async function topUp() {
    const grid = $('[data-grid]', root);
    if (!grid || !grid.hasAttribute('data-sold-last')) return;
    for (let i = 0; i < 3; i++) {
      const shown = $$('.pcard:not(.is-sold)', grid).length;
      const more = $('[data-more]', root);
      if (!more || shown >= 12) break;
      await loadMore(more);
    }
  }
  topUp();

  window.addEventListener('popstate', () => load(location.href, false));
})();
